import { Layout, OpenSans } from '@easy-expense/ui-web-core';
import { setLightness } from 'polished';
import React from 'react';

export const Badge: React.FC<{
  color: string;
  text: string;
}> = ({ color, text }) => {
  return (
    <Layout.Row
      style={{
        backgroundColor: setLightness(0.92, color),
        alignSelf: 'flex-start',
        width: 'fit-content',
      }}
      px={8}
      py={4}
      radius={4}
    >
      <OpenSans.Primary size="s-12" style={{ overflow: 'hidden', color: setLightness(0.3, color) }}>
        {text}
      </OpenSans.Primary>
    </Layout.Row>
  );
};
